<template>
  <div>
    <form class="mail-form main-modal main-modal_w700" ref="addFileForm">
      <div class="main-modal__title">
        <h2>Datei hinzufügen</h2>
      </div>

      <label
        @drag.prevent
        @dragover.prevent="onDragOver"
        @dragenter.prevent="onDragEnter"
        @dragleave.prevent="onDragLeave"
        @dragend.prevent="onDragEnd"
        @drop.prevent="onDrop"
        for="drag-zone__file"
        class="drag-zone"
        :class="{
          'drag-zone_active': isActiveZone,
        }"
      >
        <input
          @change="onUploadFile"
          type="file"
          class="drag-zone__file"
          id="drag-zone__file"
          multiple
        />

        <p class="drag-zone__title">Wählen Sie eine Datei aus oder ziehen Sie sie hierher</p>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="100px"
          viewBox="-23 0 512 512.00072"
          width="100px"
          fill="var(--menu-text-color)"
        >
          <g id="surface1">
            <path
              d="M 348.945312 221.640625 L 348.945312 124.746094 C 348.945312 121.972656 347.664062 119.410156
               345.851562 117.382812 L 237.21875 3.308594 C 235.191406 1.175781 232.308594 0 229.429688 0 L
                57.195312 0 C 25.398438 0 0 25.929688 0 57.730469 L 0 383.414062 C 0 415.214844 25.398438
                 440.71875 57.195312 440.71875 L 193.148438 440.71875 C 218.863281 483.402344 265.605469
                  512 318.851562 512 C 399.738281 512 465.792969 446.265625 465.792969 365.273438 C 465.902344
                   294.523438 415.105469 235.40625 348.945312 221.640625 Z M 240.101562 37.457031 L 312.984375
                    114.179688 L 265.710938 114.179688 C 251.625 114.179688 240.101562 102.550781 240.101562
                     88.464844 Z M 57.195312 419.375 C 37.242188 419.375 21.34375 403.367188 21.34375 383.414062
                      L 21.34375 57.730469 C 21.34375 37.667969 37.242188 21.34375 57.195312 21.34375 L 218.757812
                       21.34375 L 218.757812 88.464844 C 218.757812 114.394531 239.78125 135.523438 265.710938
                        135.523438 L 327.601562 135.523438 L 327.601562 218.863281 C 324.402344 218.757812 321.839844
                         218.4375 319.066406 218.4375 C 281.824219 218.4375 247.570312 232.738281 221.746094 255.148438
                          L 86.222656 255.148438 C 80.351562 255.148438 75.550781 259.949219 75.550781 265.816406
                           C 75.550781 271.6875 80.351562 276.488281 86.222656 276.488281 L 201.898438 276.488281
                            C 194.320312 287.160156 188.023438 297.832031 183.117188 309.570312 L 86.222656 309.570312
                             C 80.351562 309.570312 75.550781 314.371094 75.550781 320.242188 C 75.550781 326.109375
                              80.351562 330.914062 86.222656 330.914062 L 176.179688 330.914062 C 173.511719 341.585938
                               172.125 353.429688 172.125 365.273438 C 172.125 384.480469 175.859375 403.476562
                                182.582031 419.484375 L 57.195312 419.484375 Z M 318.960938 490.765625 C 249.8125
                                 490.765625 193.574219 434.527344 193.574219 365.378906 C 193.574219 296.230469
                                  249.703125 239.992188 318.960938 239.992188 C 388.214844 239.992188 444.34375
                                   296.230469 444.34375 365.378906 C 444.34375 434.527344 388.109375 490.765625
                                    318.960938 490.765625 Z M 318.960938 490.765625 "
              style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
            />
            <path
              d="M 86.222656 223.027344 L 194.320312 223.027344 C 200.191406 223.027344 204.992188 218.222656
               204.992188 212.355469 C 204.992188 206.484375 200.191406 201.683594 194.320312 201.683594 L
                86.222656 201.683594 C 80.351562 201.683594 75.550781 206.484375 75.550781 212.355469 C
                 75.550781 218.222656 80.351562 223.027344 86.222656 223.027344 Z M 86.222656 223.027344 "
              style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
            />
            <path
              d="M 326.535156 286.625 C 324.507812 284.492188 321.734375 283.210938 318.746094 283.210938 C 315.757812
               283.210938 312.984375 284.492188 310.957031 286.625 L 248.421875 353.746094 C 244.367188 358.015625
                244.6875 364.84375 248.957031 368.792969 C 253.226562 372.847656 260.160156 372.527344 264.214844
                 368.261719 L 308.394531 320.988281 L 308.394531 437.515625 C 308.394531 443.386719 313.195312
                  448.1875 319.066406 448.1875 C 324.933594 448.1875 329.738281 443.386719 329.738281 437.515625
                   L 329.738281 320.988281 L 373.59375 368.261719 C 375.730469 370.5 378.503906 371.675781
                    381.386719 371.675781 C 383.945312 371.675781 386.507812 370.714844 388.640625 368.792969
                     C 392.910156 364.738281 393.230469 358.015625 389.175781 353.746094 Z M 326.535156 286.625 "
              style=" stroke:none;fill-rule:nonzero;fill-opacity:1;"
            />
          </g>
        </svg>
      </label>

      <div class="uploaded-info">
        <div class="uploaded-info__file" v-for="(file, index) in files" :key="index">
          <p class="uploaded-info__file-text">{{ index + 1 }}.</p>
          <p class="uploaded-info__file-text">{{ file.name }}</p>

          <svg
            @click="removeFile(file.name)"
            width="14px"
            height="14px"
            class="uploaded-info__file-cancel"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512.001 512.001"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  fill="var(--menu-text-color)"
                  d="M294.111,256.001L504.109,46.003c10.523-10.524,10.523-27.586,
                  0-38.109c-10.524-10.524-27.587-10.524-38.11,0L256,217.892
                        L46.002,7.894c-10.524-10.524-27.586-10.524-38.109,0s-10.524,
                        27.586,0,38.109l209.998,209.998L7.893,465.999
                        c-10.524,10.524-10.524,27.586,0,38.109c10.524,10.524,27.586,10.523,38.109,
                        0L256,294.11l209.997,209.998
                        c10.524,10.524,27.587,10.523,38.11,0c10.523-10.524,10.523-27.586,0-38.109L294.111,256.001z"
                />
              </g>
            </g>
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
          </svg>
        </div>
      </div>

      <div class="main-form__buttons main-form__buttons_center">
        <span class="main-button main-button_cancel" @click="$emit('close')">
          {{
          $t("global.cancel")
          }}
        </span>
        <button
          class="main-button main-button_success"
          type="reset"
          :disabled="!isValid"
          :class="{
            disabled: !isValid,
          }"
          @click="uploadFiles"
        >{{ $t("global.save") }}</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
    name: 'add-file',
    computed: {
        isValid() {
            return true
        },
    },
    data() {
        return {
            files: [],
            isActiveZone: false,
        }
    },
    methods: {
        removeFile(key) {
            this.files = this.files.filter((file) => file.name !== key)
        },
        onUploadFile(e) {
            try {
                Array.from(e.target.files).forEach((file) => {
                    const sizeInMB = +(file.size / (1024 * 1024)).toFixed(2)
                    if (sizeInMB > 50) throw new Error('File size')
                })
                this.files = this.files.concat(Array.from(e.target.files))
                this.$refs.addFileForm.reset()
            } catch (err) {
                this.$notify({
                    title: 'Ein Fehler ist aufgetreten',
                    message: 'Die Dateigröße ist zu groß. Maximal zulässige Größe 50 MB',
                    duration: 5000,
                })
            }
        },
        uploadFiles() {
            this.$emit('uploadFiles', this.files)
        },
        onDrop(e) {
            try {
                Array.from(e.dataTransfer.files).forEach((file) => {
                    const sizeInMB = +(file.size / (1024 * 1024)).toFixed(2)
                    if (sizeInMB > 50) throw new Error('File size')
                })

                this.isActiveZone = false
                this.files = this.files.concat(Array.from(e.dataTransfer.files))
            } catch (err) {
                this.$notify({
                    title: 'Ein Fehler ist aufgetreten',
                    message: 'Die Dateigröße ist zu groß. Maximal zulässige Größe 50 MB',
                    duration: 5000,
                })
            }
        },
        onDragOver() {
            this.isActiveZone = true
        },
        onDragEnter() {
            this.isActiveZone = true
        },
        onDragEnd() {
            this.isActiveZone = false
        },
        onDragLeave() {
            this.isActiveZone = false
        },
    },
}
</script>

<style lang="scss" scoped>
.drag-zone {
  width: 100%;
  height: 400px;
  border: 1px dashed #5d5d5d;
  color: var(--menu-text-color);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transition: all 0.3s ease-in;

  &_active {
    background-color: var(--chat-hover) !important;
  }

  &:hover {
    cursor: pointer;
    background-color: var(--bg-color);
  }

  &__file {
    display: none;
  }

  &__title {
    margin-bottom: 36px;
    font-size: 24px;
    max-width: 70%;
    text-align: center;
  }
}

.uploaded-info {
  margin-top: 16px;
  color: var(--menu-text-color);

  &__file {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 14px;

    &-text {
      margin-right: 16px;
    }

    &-cancel {
      cursor: pointer;
    }

    svg {
      margin-bottom: 2px;
    }
  }
}
</style>
